import { Button, Modal } from "@xola/ui-kit";
import { noop } from "lodash";
import React, { ReactNode } from "react";
import { Except } from "type-fest";

interface AlertModalProps {
    isOpen: boolean;
    title: string;
    confirmText?: string;
    confirmColor?: string;
    children: ReactNode;
    onConfirm?: () => void;
}

export const AlertModal = (props: AlertModalProps) => {
    return (
        <Modal isOpen={props.isOpen} onClose={noop}>
            <ModalContent {...props}>{props.children}</ModalContent>
        </Modal>
    );
};

const ModalContent = ({
    title,
    confirmText = "OK",
    confirmColor = "primary",
    children,
    onConfirm,
}: Except<AlertModalProps, "isOpen">) => {
    return (
        <>
            <Modal.Header>{title}</Modal.Header>
            <Modal.Body>{children}</Modal.Body>
            <Modal.Footer className="flex justify-end">
                <Button color={confirmColor} onClick={onConfirm}>
                    {confirmText}
                </Button>
            </Modal.Footer>
        </>
    );
};
